import axios from "axios";
import { routes } from "../utils";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

let controller = new AbortController();

function getSignalConfig(config?: any) {
	return {
		...config,
		signal: controller.signal,
	};
}

axios.interceptors.response.use(null, (error) => {
	if (axios.isCancel(error)) {
		console.warn("Request canceled:", error.message);
		return new Promise(() => {}); // Axios no lo trata como error
	}
	const expectedError =
		!error.config?.url?.endsWith("/token") &&
		error.response &&
		error.response.status >= 400 &&
		error.response.status < 500;

	if (expectedError) {
		try {
			if (error.response.status === 401) {
				controller.abort();
				controller = new AbortController(); // Creamos uno nuevo para futuras requests
				window.location.assign(routes.LOGOUT);
			}
		} catch (e) {
			console.error("Error handling 401", e);
		}
	}

	return Promise.reject(error);
});

function setAuthToken(authToken: string) {
	localStorage.setItem("authToken", authToken);
	axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
}

export default {
	get: (url: string, config?: any) => axios.get(API_ENDPOINT + url, getSignalConfig(config)),
	post: (url: string, data: any, config?: any) => axios.post(API_ENDPOINT + url, data, getSignalConfig(config)),
	put: (url: string, data: any, config?: any) => axios.put(API_ENDPOINT + url, data, getSignalConfig(config)),
	delete: (url: string, config?: any) => axios.delete(API_ENDPOINT + url, getSignalConfig(config)),
	setAuthToken,
	parseBodyParams: (params: any) => {
		const bodyParams: any = {};
		Object.keys(params).forEach((key) => {
			if (!Array.isArray(params[key])) {
				bodyParams[key] = params[key];
			} else if (params[key].length > 0) {
				bodyParams[key] = params[key].map((value: any) => value.id);
			}
		});
		return bodyParams;
	},
};
